import { action, computed, makeObservable, observable } from 'mobx';
import { EmailTemplateRef, SentEmail } from '../../models';
import { parseISO } from 'date-fns';

export class EmailPageUiStore {
  @observable sentEmails: SentEmail[] = [];
  @observable emailTemplateRefs: EmailTemplateRef[] = [];

  constructor() {
    makeObservable(this);
  }

  @action
  resetStates(): void {
    this.sentEmails = [];
    this.emailTemplateRefs = [];
  }

  @action
  setSentEmails(sentEmails: SentEmail[]): void {
    this.sentEmails = sentEmails;
  }

  @action
  setEmailTemplateRefs(emailTemplateRefs: EmailTemplateRef[]): void {
    this.emailTemplateRefs = emailTemplateRefs;
  }

  @computed
  get sortedEmailTemplateRefs(): EmailTemplateRef[] {
    return this.emailTemplateRefs.toSorted((current, next) => {
      const dateA = current.lastUpdatedDateTime ? parseISO(current.lastUpdatedDateTime) : new Date(0);
      const dateB = next.lastUpdatedDateTime ? parseISO(next.lastUpdatedDateTime) : new Date(0);
      return dateB.getTime() - dateA.getTime();
    });
  }
}
